import React, { useMemo } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { Item, DataRow } from '../types';

interface CompoundSelectorProps {
    items: Item<DataRow>[];
    selectedCompounds: string[];
    setSelectedCompounds: (compounds: string[]) => void;
    selectedProducts: string[];
    selectedClass: string;
    diseaseInchiKeys: string[];
}

const CompoundSelector: React.FC<CompoundSelectorProps> = ({
                                                               items,
                                                               selectedCompounds,
                                                               setSelectedCompounds,
                                                               selectedProducts,
                                                               selectedClass,
                                                               diseaseInchiKeys
                                                           }) => {
    const compoundOptions = useMemo(() => {
        const compounds = new Set<string>();
        items.forEach(item => {
            item.DATA.forEach((row: DataRow) => {
                const productKey = `${row.PRODUCT || 'Unknown'} (${row.ANALYSIS_TYPE || 'Unknown'})`;
                if (selectedProducts.length === 0 || selectedProducts.includes(productKey)) {
                    if (row.COMPOUND_NAME && row.COMPOUND_NAME !== 'Unknown') {
                        if (selectedClass === 'All' || row.CLASS === selectedClass) {
                            if (diseaseInchiKeys.length === 0 || diseaseInchiKeys.includes(row.INCHIKEY || '')) {
                                compounds.add(row.COMPOUND_NAME);
                            }
                        }
                    }
                }
            });
        });
        const options = ['All', ...Array.from(compounds).sort()];
        console.log('Compound Options:', options);
        return options;
    }, [items, selectedProducts, selectedClass, diseaseInchiKeys]);

    const handleChange = (event: SelectChangeEvent<string[]>) => {
        const value = event.target.value as string[];
        console.log('Handle Change - New Value:', value);

        // If value is empty, select "All"
        if (value.length === 0) {
            setSelectedCompounds(['All']);
            return;
        }

        // If "All" is selected with other compounds, keep only specific compounds
        if (value.includes('All') && value.length > 1) {
            const filteredValue = value.filter(v => v !== 'All');
            setSelectedCompounds(filteredValue);
            return;
        }

        // Otherwise, set the selected value
        setSelectedCompounds(value);
    };

    console.log('Selected Compounds:', selectedCompounds);

    return (
        <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Compounds</InputLabel>
            <Select
                multiple
                value={selectedCompounds}
                onChange={handleChange}
                label="Compounds"
                size="small"
                renderValue={(selected) => selected.join(', ')}
            >
                {compoundOptions.map((compound) => (
                    <MenuItem key={compound} value={compound}>
                        <Checkbox checked={selectedCompounds.includes(compound)} />
                        <ListItemText primary={compound} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CompoundSelector;
